import React from 'react';
import { WorkflowDocumentPicker } from 'src/app/workflows/WorkflowDocumentPicker';
import { ResourceAttachmentDto } from 'src/api/FiretrolApiClient';
import { useSubmittalDocumentOptions } from 'src/api/queries/submittals/useSubmittalQueries';
import { useAttachSubmittalDocument } from 'src/api/queries/submittals/useSubmittalMutations';

export interface ISubmittalDocumentPickerProps {
  jobId: number;
  onAttached: (attachment: ResourceAttachmentDto) => void;
}

export const SubmittalDocumentPicker: React.FC<
  ISubmittalDocumentPickerProps
> = ({ jobId, onAttached }) => {
  const { data } = useSubmittalDocumentOptions(jobId);
  const attach = useAttachSubmittalDocument();

  return (
    <WorkflowDocumentPicker
      jobId={jobId}
      onAttached={onAttached}
      options={data ?? []}
      attachFromDocument={(id, documentId) =>
        attach.mutateAsync({ jobId: id, documentId })
      }
      attaching={attach.isPending}
    />
  );
};
